import { jsx as _jsx } from "react/jsx-runtime";
import { colors, radius, typography } from '@mehilainen/mds-tokens';
import { svgIconClasses, switchClasses, } from '@mui/material';
// NOTE: Do not import these from lib root (src/index)! Will cause circular deps
import { RadioOnAlt, RadioOff, CheckboxOn, CheckboxOff } from '../../../icons';
import { focusVisible, muiFocusVisibleCssClass } from '../shared';
export const getThemeSelections = (tokens) => ({
    MuiRadio: {
        defaultProps: {
            checkedIcon: _jsx(RadioOnAlt, {}),
            icon: _jsx(RadioOff, {}),
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                padding: 0,
                backgroundColor: 'unset',
                '& > svg': {
                    color: colors.Gray700,
                    width: tokens.uiElementSelections.iconSize,
                    height: tokens.uiElementSelections.iconSize,
                },
                '&:hover > svg': {
                    color: colors.Primary500,
                },
                '&.Mui-checked > svg': {
                    color: colors.Primary500,
                },
                '&.Mui-disabled > svg': {
                    color: colors.Gray500,
                },
                [`&${muiFocusVisibleCssClass} > svg`]: Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px', borderRadius: radius[1000].rem }),
            },
        },
    },
    MuiCheckbox: {
        defaultProps: {
            checkedIcon: _jsx(CheckboxOn, {}),
            icon: _jsx(CheckboxOff, {}),
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                padding: 0,
                '& > svg': {
                    color: colors.Gray700,
                    width: tokens.uiElementSelections.iconSize,
                    height: tokens.uiElementSelections.iconSize,
                },
                '&:hover > svg': {
                    color: colors.Primary500,
                },
                '&.Mui-checked > svg': {
                    color: colors.Primary500,
                },
                '&.Mui-disabled > svg': {
                    color: colors.Gray500,
                },
                [`&${muiFocusVisibleCssClass} > svg`]: Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px', borderRadius: '2px' }),
            },
        },
    },
    MuiSwitch: {
        defaultProps: {
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                marginTop: '-3px',
                // NOTE: Mehidoc puts border-box on all (!) elements, this messes up totally switch styles
                '& *': {
                    boxSizing: 'content-box !important',
                },
                padding: 0,
                height: tokens.uiElementSelections.toggleHeight,
                width: tokens.uiElementSelections.toggleWidth,
                overflow: 'visible',
            },
            track: {
                borderRadius: 999,
                backgroundColor: 'unset',
                borderWidth: '1.5px',
                borderColor: colors.Primary500,
                borderStyle: 'solid',
                opacity: 1,
            },
            thumb: {
                width: tokens.uiElementSelections.thumbSize,
                height: tokens.uiElementSelections.thumbSize,
                borderRadius: 999,
                boxShadow: 'unset',
                borderWidth: '1.5px',
                borderColor: colors.Primary500,
                borderStyle: 'solid',
            },
            switchBase: {
                padding: '3.5px',
                '&.Mui-disabled': {
                    color: colors.Gray500,
                    [`& > .${switchClasses.thumb}`]: {
                        borderColor: colors.Gray500,
                        backgroundColor: colors.White, // To override disabled color change
                    },
                },
                [`& > .${svgIconClasses.root}`]: {
                    marginLeft: '-3px',
                    marginTop: '-7px',
                },
                [`&.Mui-disabled + .${switchClasses.track}`]: {
                    borderColor: colors.Gray500,
                    opacity: 1,
                },
                '&.Mui-checked': {
                    color: colors.White,
                    WebkitTransform: 'translateX(45%)',
                    transform: 'translateX(45%)',
                    [`& + .${switchClasses.track}`]: {
                        opacity: 1,
                        backgroundColor: colors.Primary500,
                    },
                    [`&.Mui-disabled + .${switchClasses.track}`]: {
                        backgroundColor: colors.Gray500,
                        borderColor: colors.Gray500,
                        opacity: 1,
                    },
                    [`& > .${switchClasses.thumb}`]: {
                        borderColor: colors.White,
                        backgroundColor: colors.White, // To override disabled color change
                    },
                },
                // Outline the track
                [`&${muiFocusVisibleCssClass} + .${switchClasses.track}`]: Object.assign(Object.assign({}, focusVisible), { outlineOffset: '3px' }),
            },
        },
    },
    MuiFormControlLabel: {
        styleOverrides: {
            root: {
                gap: tokens.uiElementSelections.gap,
                margin: 0,
            },
            label: {
                fontSize: typography.baseTypography.size[400].rem,
                lineHeight: typography.baseTypography.height.Medium,
                color: colors.Gray900,
                '& > span': {
                    color: colors.Gray700,
                    fontSize: typography.baseTypography.size[200].rem,
                    lineHeight: typography.baseTypography.height.Small,
                    display: 'block',
                    paddingTop: '4px',
                },
                '&.Mui-disabled': {
                    color: colors.Gray500,
                    '& > span': {
                        color: colors.Gray500,
                    },
                },
            },
        },
    },
});
